import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=dbfcb9b8&scoped=true"
import script from "./chat.vue?vue&type=script&lang=ts"
export * from "./chat.vue?vue&type=script&lang=ts"
import style0 from "./chat.vue?vue&type=style&index=0&id=dbfcb9b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbfcb9b8",
  null
  
)

export default component.exports